import vInputText from './InputText.vue';

export { vInputText };



// WEBPACK FOOTER //
// ./src/baseComponents/components/InputText/index.js